import React from "react";
import {Modal, FormGroup} from "react-bootstrap";
import { AbstractAdminEntityService } from "../../services/AbstractAdminEntityService";
import { DataTable } from "../list/list/DataTable";
import { PagerModel } from "../list/list/PagerModel";
import "./FormListSubmission.scss";

interface ModelItem{
    value?:number;
    result?:string;
    description?:string;
}

interface State{
    iterationValues? : ModelItem[];
    flagSubmitValues?:boolean;
    pager : PagerModel;
}

interface PropsModal { 
    show?: boolean,
    okLabel: string,
    cancelLabel?: string,
    heading: string,
    description?: string, 
    okClassName?: string,
    cancelClassName?: string,
    hideCancelButton? : boolean,
    onOk: () => void , 
    onCancel?: () => void,
    descriptionAlert? : boolean,
    modelAttributeName : string;
    modelObject : any;
    submit?: Promise<any> | undefined;
}


export class FormListSubmission extends React.Component<PropsModal, State>{

    // en el constructo agarrar el iteration values 
    constructor(props:PropsModal) {
        super(props);
        var pager = new PagerModel();
        pager.limit = 10;
        let iterationValues: ModelItem[] = []; 
        this.props.modelObject[this.props.modelAttributeName].forEach((item:any)=>{
            iterationValues.push({value: item});
        })


        this.state = {
            pager : pager, 
            iterationValues: iterationValues, 
            flagSubmitValues:false, 
        };

        
    }

    async onCancel() {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    async doOk() {
        this.props.onOk();
    }

    getActions() {
        let btnClass = this.props.okClassName ? this.props.okClassName : "btn-danger";
        return (
            <FormGroup className="form-group">
                <div> 
                    {
                        this.state.flagSubmitValues ? (
                            <a  className={`btn ${btnClass} disabled`} onClick={()=> console.log("Submit is disabled")}>{this.props.okLabel}</a>
                        ) : (
                            <a  className={`btn ${btnClass}`} onClick={()=> this.onSubmit(0)}>{this.props.okLabel}</a>
                        )
                    }
                </div>
            </FormGroup>
        );
    }

    //iterar sobre iteracion values // usar model attributes // usar service
    onSubmit(index: number){
        this.setState({flagSubmitValues:true}); // hide button submit modal
        if(this.state.iterationValues === null || this.state.iterationValues === undefined || this.state.iterationValues.length <= index ){
            return;
        }
        
        let item = this.state.iterationValues[index];
        let request = Object.assign({}, this.props.modelObject);
        request[this.props.modelAttributeName] = item.value;

        if(typeof(this.props.submit) != "undefined") {
            let promise = this.props.submit(request);
            
            promise.then((response:any)=>{
                this.updateModel(index, "OK",  response);
            }).catch(err => {
                console.log("Promise throw error", err);
                this.updateModel(index, "FAIL",  err.message);
            }).finally(()=>{
                this.onSubmit(index+1);
            });
        }

    }


    updateModel(index: number, result:string, description:string){
         // 1. Make a shallow copy of the items
         let items = [...this.state.iterationValues!];
         // 2. Make a shallow copy of the item you want to mutate
         let item = {...items[index]};
         // 3. Replace the property you're intested in
         item.value = item.value!;
         item.result = result;
         item.description = description;
         // 4. Put it back into our array. N.B. we *are* mutating the array here, 
         //    but that's why we made a copy first
         items[index] = item;
         // 5. Set the state to our new copy
         console.log(items);

         this.setState({iterationValues:items});
    }

    wait(ms: any){
        let start = new Date().getTime();
        let end = start;
        while(end < start + ms) {
          end = new Date().getTime();
       }
    }

    onPagerChange(pager : PagerModel) {
        console.log("Pager", pager);
        this.setState({pager : pager});
    }
   
    getItems() {
        const { pager, iterationValues } = this.state;
        let itemsLenlength = iterationValues ? iterationValues.length : 0;
        let visibleItems = itemsLenlength && itemsLenlength > pager.offset ? iterationValues.slice(pager.offset, pager.offset + pager.limit) : [];
        return <DataTable  
            items={visibleItems ? visibleItems : []}
            onPagerChange={this.onPagerChange.bind(this)}
            setMaxLimit={100}
            columns={this.getColumns()}
            pager={new PagerModel(pager, iterationValues ? iterationValues.length : 0)}
            loading={false}
            itemsUpdating={[]}
            nameResource={"Input List"}
        />;
    }

    getColumns(){
        return [
            { property : "value", name : "Value", orderBy : "id"},
            { property : "result", name : "Result",
                renderer : (property: string, name: string, item: any) =>{
                    console.log("Render");
                    if (item[property] =="OK") return <i className="fe-check-circle" aria-hidden="true"></i>
                    if (item[property] =="FAIL") return <i className="fe-delete" aria-hidden="true"></i>
                    return
                }
            },
            { property : "description", name : "Description"}
        ];
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.onCancel.bind(this)} aria-labelledby="contained-modal-title">
                <Modal.Header  closeButton>
                    <Modal.Title id="contained-modal-title">{this.props.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.getItems()}
                </Modal.Body>
                <Modal.Footer>
                    {this.getActions()}
                </Modal.Footer>
            </Modal>
       );
    }
}
